export type ReadingView = 'reading' | 'commentary' | 'curated' | 'literature' | 'literature-list' | 'reference' | 'toc'

// Shared across callers so `back()` can restore focus from any component.
// Safe because only one reading surface is mounted at a time.
let triggerElement: HTMLElement | null = null

export function useReadingView(key: string) {
  const stack = useState<ReadingView[]>(key, () => ['reading'])

  const activeView = computed<ReadingView>(() => stack.value[stack.value.length - 1] ?? 'reading')

  const previousView = computed<ReadingView>(() => stack.value[stack.value.length - 2] ?? 'reading')

  // 'toc' view is only pushed under isMobileViewport(), tablet/desktop never reach it
  function open(view: ReadingView, trigger?: HTMLElement) {
    if (trigger) {
      triggerElement = trigger
    }
    if (activeView.value !== view) {
      stack.value = [...stack.value, view]
    }
  }

  function back() {
    if (stack.value.length > 1) {
      stack.value = stack.value.slice(0, -1)
    }
    if (activeView.value === 'reading' && (isMobileViewport() || isTabletViewport())) {
      const el = triggerElement
      nextTick(() => {
        el?.focus({ preventScroll: true })
      })
    }
  }

  function reset() {
    triggerElement = null
    stack.value = ['reading']
  }

  return {
    activeView,
    previousView,
    open,
    back,
    reset,
  }
}
